import {useState} from 'react';
import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Collapse from "react-bootstrap/Collapse";

import { copyReplaceAt } from './functions.js'

export function addParameter(_this) {
  _this.setState({ parameters: _this.state.parameters.slice().concat({ name:'', required: true})});
}

export function deleteParameter(index, _this) {
  _this.setState({ parameters: _this.state.parameters.slice(0, index).concat(_this.state.parameters.slice(index + 1)) },
       () => {
       for (var i in _this.state.parameters)  {
         _this.parameters[i].value = _this.state.parameters[i].name
         _this.parametersRequired[i].checked = _this.state.parameters[i].required
       }})
}

export function parameterChanged(index, name, required, _this) {
  _this.setState(copyReplaceAt('parameters', _this.state.parameters, index, { name, required }))
}

  export function renderParameters(_this) {

    return (
      <React.Fragment>
            <Form.Group className="mb-0">
              <Form.Label className="bold">Parameters</Form.Label>
              <Button type="button" className="deleteaddbutton" aria-label="New" onClick={(event) => addParameter(_this)}><span className="fa fa-plus"></span></Button>
            </Form.Group>

            {_this.state.parameters.map((el, index) =>
              <Row key={index}>
              <Col md="auto">
                <span className="bold">{index + 1}</span>
              </Col>
                <Col>
                  <Form.Group>
                    {/*<Form.Label className={el.required? "required":""}>Parameter</Form.Label>*/}
                    <Form.Label>Parameter</Form.Label>
                    <Form.Control
                      ref={node => (_this.parameters[index] = node)}
                      onChange={(event) => parameterChanged(index, event.target.value, _this.parametersRequired[index].checked, _this)}
                      defaultValue={el.name}>
                    </Form.Control>
                    <Form.Check label="Required" ref={node => (_this.parametersRequired[index] = node)}
                      onChange={(event) => parameterChanged(index, _this.parameters[index].value, event.target.checked, _this)}
                      defaultChecked={el.required}/>
                  </Form.Group>
                </Col>
                <Col md="auto">
                  <Button type="button" className="deleteeditbutton" aria-label="New" onClick={(event) => deleteParameter(index, _this)}><span className="fa fa-times"></span></Button>
                </Col>

              </Row>)}

          </React.Fragment>
  )}

export function renderFillParameters(parameters, _this) {

  return (
    <React.Fragment>
      {parameters && parameters.map((param, index) =>
      <Form.Group key={index}>
        <Form.Label className={param.required ? "required":""}>Parameter: {param.name} {param.description ? " - " + param.description : ""}</Form.Label>
        <Form.Control type={param.hidden && param.hidden ? "password" : "text"} ref={node => (_this[param.name] = node)}
                      defaultValue={_this.findParameterValue(param.name)}/>
      </Form.Group>)}
    </React.Fragment>
  )

}


export function renderDatasetGroups(dataset, element, _this) {
  return (
    <React.Fragment>
    {(dataset.multiGroup || dataset.inheritedDatasets) &&
      <React.Fragment>
        <Form.Label>Dataset parts selection</Form.Label>
        <div className="groupBox">
          {dataset.multiGroup &&
          <React.Fragment>
            <Form.Group>
              <Form.Check label="All groups" ref={node => (_this.allGroups = node)}
                onChange={() => _this.groups.value = ""}
                defaultChecked={element && element.datasetGroups != null ? false : true }/>
            </Form.Group>
            <Form.Group>
              <Form.Label>Groups</Form.Label>
              <Form.Control ref={node => (_this.groups = node)}
                    onChange={() => _this.allGroups.checked = false}
                    pattern="([0-9]+, )*[0-9]+"
                    defaultValue={element && element.datasetGroups != null ? element.datasetGroups.join(", ") : ""}
               />
            </Form.Group>
          </React.Fragment>}
          {dataset.inheritedDatasets &&
            <Form.Group>
              <Form.Check label="Inherited datasets" ref={node => (_this.inheritedDatasets = node)}
                defaultChecked={element && element.inheritedDatasets ? true : false }/>
            </Form.Group>}
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}

export function getDatasetGroups(dataset, _this) {
  var groups = null;
  if (dataset.multiGroup && _this.groups.value.length > 0) {
    groups = [];
    for (var g of _this.groups.value.split(",")) {
      groups.push(parseInt(g.trim()));
    }
  }

  return { groups: groups, inheritedDatasets: dataset.inheritedDatasets && _this.inheritedDatasets && _this.inheritedDatasets.checked }
}
